<template>
    <v-snackbar
      v-model="snackbar.visible"
      :timeout="snackbar.timeout"
      :multi-line="snackbar.multiline === true"
      :color="snackbar.color"
      align-center
      app
      right
      top
      rounded="2px"
    >
      {{ snackbar.text }}
      <v-btn text="" dark="" @click="closeAlert">Close</v-btn>
    </v-snackbar>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  computed: {
    snackbar() {
      return this.$store.state.snackbar;
    }
  },
  methods: {
    ...mapMutations(["closeAlert"])
  }
};
</script>
